import { z } from "zod";
import { nonEmptyString } from "./nonEmptyString.js";
import { uploadedFileBucketSchema } from "./uploadedFileBucketSchema.js";

export const uploadedFileSchema = z.object({
	path: nonEmptyString,
	size: z.number().optional(),
	title: nonEmptyString.optional(),
	type: nonEmptyString,
	bucket: uploadedFileBucketSchema,
});
